import { ArrowRight } from 'lucide-react';
import type { CSSProperties } from 'react';
import type { Article } from '../content/articleTypes';
import { articlePath } from '../content/articles';

export const ArticleCard = ({
  article,
  featured = false,
  motionIndex = 0,
}: {
  article: Article;
  featured?: boolean;
  motionIndex?: number;
}) => (
  <article
    className={`as-guide-card${featured ? ' as-guide-card-featured' : ''}`}
    data-motion="card"
    style={{ '--as-motion-order': Math.min(motionIndex, 2) } as CSSProperties}
  >
    <a className="as-guide-card-image" href={articlePath(article.slug)} tabIndex={-1} aria-hidden="true">
      <img
        src={article.image}
        alt=""
        width="1200"
        height="630"
        loading="lazy"
        decoding="async"
      />
    </a>
    <div className="as-guide-card-copy">
      <p className="as-guide-meta"><span>{article.category}</span><span>{article.readingTime}</span></p>
      <h3><a href={articlePath(article.slug)}>{article.title}</a></h3>
      <p>{article.intro}</p>
      <a className="as-guide-card-link" href={articlePath(article.slug)}>
        Lire le guide <ArrowRight size={15} aria-hidden="true" />
      </a>
    </div>
  </article>
);
